/**
 * OI containment helpers — "is this point inside the OI polygon".
 *
 * Used only by the T+60s prediction (lib/map/markers/predProjection.ts and
 * the drones store's `pred1min.inside`). OI conformance is NOT derived here any
 * more: the OI's status is the RTM authority's `rtm_state` (ENG-213).
 */
import { booleanPointInPolygon } from '@turf/turf';
import type { Feature, Polygon } from 'geojson';
import { queryClient } from '@/lib/query';
import type { OiSummary } from '@/lib/api/types';

/** Build a quick lookup from aircraft drone_id → assigned OI summary. */
export function oiByAircraft(): Map<string, OiSummary> {
  const list = queryClient.getQueryData<OiSummary[]>(['oi', 'list']) ?? [];
  const m = new Map<string, OiSummary>();
  for (const oi of list) m.set(oi.aircraft, oi);
  return m;
}

function pointInsidePolygon(lng: number, lat: number, polygon: Polygon): boolean {
  const feat: Feature<Polygon> = { type: 'Feature', geometry: polygon, properties: {} };
  return booleanPointInPolygon([lng, lat], feat);
}

/** True if (lng,lat) lies inside the polygon. False if outside OR no polygon. */
export function isInsideOi(lng: number, lat: number, polygon: Polygon | undefined | null): boolean {
  if (!polygon) return false;
  return pointInsidePolygon(lng, lat, polygon);
}
